(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contentsquare-tag"] && !Shopify.designMode) return;
  try {
    (function () {
    var marker = document.getElementById('spalvinu-contentsquare-tag');
    if (!marker) return;

    var loaded = false;

    function clearOptout() {
      if (document.cookie.indexOf('_cs_optout=') === -1) return;
      var labels = window.location.hostname.split('.');
      for (var i = 0; i < labels.length - 1; i++) {
        document.cookie = '_cs_optout=; Max-Age=0; path=/; domain=' + labels.slice(i).join('.');
      }
      document.cookie = '_cs_optout=; Max-Age=0; path=/';
    }

    function load() {
      loaded = true;
      clearOptout();
      var script = document.createElement('script');
      script.src = marker.getAttribute('data-src');
      script.async = true;
      document.head.appendChild(script);
    }

    function syncConsent() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return false;

      if (privacy.analyticsProcessingAllowed()) {
        if (!loaded) load();
      } else if (loaded) {
        window._uxa = window._uxa || [];
        window._uxa.push(['optout']);
      }
      return true;
    }

    function loadPrivacy() {
      if (syncConsent()) return;
      var shopify = window.Shopify;
      if (shopify && typeof shopify.loadFeatures === 'function') {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) syncConsent();
        });
      } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadPrivacy, { once: true });
      }
    }

    document.addEventListener('visitorConsentCollected', syncConsent);
    loadPrivacy();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["google-ads-tag"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!document.getElementById('spalvinu-google-ads-tag')) return;
    if (typeof window.gtag !== 'function') return;

    function syncConsent() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return false;

      var analyticsAllowed = privacy.analyticsProcessingAllowed();
      var marketingAllowed = privacy.marketingAllowed();
      var sharingAllowed = privacy.saleOfDataAllowed();

      window.gtag('consent', 'update', {
        analytics_storage: analyticsAllowed ? 'granted' : 'denied',
        ad_storage: marketingAllowed ? 'granted' : 'denied',
        ad_user_data: marketingAllowed && sharingAllowed ? 'granted' : 'denied',
        ad_personalization: marketingAllowed && sharingAllowed ? 'granted' : 'denied'
      });
      return true;
    }

    function loadPrivacy() {
      if (syncConsent()) return;
      var shopify = window.Shopify;
      if (shopify && typeof shopify.loadFeatures === 'function') {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) syncConsent();
        });
      } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadPrivacy, { once: true });
      }
    }

    document.addEventListener('visitorConsentCollected', syncConsent);
    loadPrivacy();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lod-toggle"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'spalvinu:customer_lod:v1';
    var VALUES = ['option_a', 'option_b', 'option_c'];

    function current() {
      if (window.CustomerLod && typeof window.CustomerLod.get === 'function') {
        var state = window.CustomerLod.get();
        if (state && state.value) return state.value;
      }
      // Until window.CustomerLod exists (it is defined at the end of <body>),
      // read the same storage key, with the same option_b default.
      try {
        var stored = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (stored && VALUES.indexOf(stored.value) !== -1) return stored.value;
      } catch (err) {}
      return 'option_b';
    }

    function render() {
      var value = current();
      document.querySelectorAll('[data-lod-toggle]').forEach(function (group) {
        var options = group.querySelectorAll('[data-lod-toggle-option]');
        var anyChecked = false;
        options.forEach(function (option) {
          var checked = option.getAttribute('data-lod-toggle-option') === value;
          if (checked) anyChecked = true;
          option.setAttribute('aria-checked', checked ? 'true' : 'false');
          option.tabIndex = checked ? 0 : -1;
        });
        // A stored level with no button here still leaves the group reachable.
        if (!anyChecked && options[0]) options[0].tabIndex = 0;
      });
    }

    function choose(option) {
      var value = option.getAttribute('data-lod-toggle-option');
      if (window.CustomerLod && typeof window.CustomerLod.set === 'function') {
        window.CustomerLod.set(value);
      }
      render();
    }

    document.addEventListener('click', function (event) {
      var option = event.target.closest && event.target.closest('[data-lod-toggle-option]');
      if (option) choose(option);
    });

    // Radio-group keys: the arrows move the choice and focus together.
    document.addEventListener('keydown', function (event) {
      var option = event.target.closest && event.target.closest('[data-lod-toggle-option]');
      if (!option) return;
      var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
      if (!step) return;
      event.preventDefault();
      var options = Array.prototype.slice.call(option.closest('[data-lod-toggle]').querySelectorAll('[data-lod-toggle-option]'));
      var next = options[(options.indexOf(option) + step + options.length) % options.length];
      choose(next);
      next.focus();
    });

    document.addEventListener('customer-lod:ready', render);
    document.addEventListener('customer-lod:changed', render);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', render);
    } else {
      render();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-email-pdf"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__spalvinuEmailPdf) return;
    window.__spalvinuEmailPdf = true;

    var STORE_KEY = 'spalvinu-email';
    var REVISION = '2024-10-15';

    function root(el) {
      return el && el.closest ? el.closest('[data-email-pdf]') : null;
    }

    function post(path, company, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.ok) return;
        return res.text().then(function (body) {
          throw new Error('Klaviyo ' + path + ' ' + res.status + ' ' + body);
        });
      });
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest && event.target.closest('[data-email-pdf-open]');
      if (opener) {
        var box = root(opener);
        var sheet = box.querySelector('[data-email-pdf-sheet]');
        var input = box.querySelector('[data-email-pdf-input]');
        try {
          if (input && !input.value) input.value = localStorage.getItem(STORE_KEY) || '';
        } catch (e) {}
        if (sheet.showModal) sheet.showModal();
        else sheet.setAttribute('open', '');
        return;
      }
      var closer = event.target.closest && event.target.closest('[data-email-pdf-close]');
      if (closer) {
        var dialog = closer.closest('[data-email-pdf-sheet]');
        if (dialog.close) dialog.close();
        else dialog.removeAttribute('open');
        return;
      }
      // A tap on the dimmed page around the sheet closes it.
      if (event.target.matches && event.target.matches('[data-email-pdf-sheet]') && event.target.close) {
        var rect = event.target.getBoundingClientRect();
        if (event.clientY < rect.top) event.target.close();
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('[data-email-pdf-form]');
      if (!form) return;
      event.preventDefault();
      var box = root(form);
      var input = form.querySelector('[data-email-pdf-input]');
      var status = form.querySelector('[data-email-pdf-status]');
      var submit = form.querySelector('[data-email-pdf-submit]');
      var label = form.querySelector('[data-email-pdf-submit-label]');
      var email = (input.value || '').trim();

      status.className = 'spalvinu-email-pdf__status';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        status.textContent = status.getAttribute('data-invalid');
        status.classList.add('is-error');
        input.focus();
        return;
      }

      var idle = label.textContent;
      submit.disabled = true;
      label.textContent = submit.getAttribute('data-busy-label');
      status.textContent = '';

      var company = box.getAttribute('data-company');
      var optin = form.querySelector('[data-email-pdf-newsletter]');
      var newsletter = !!(optin && optin.checked);
      var list = newsletter ? box.getAttribute('data-list') : '';
      var profile = { data: { type: 'profile', attributes: { email: email } } };
      // The storefront language goes on the profile with the subscription
      // itself, so segments that split the list by language (Klaviyo:
      // newsletter_language = lt) and the list's welcome flow see it at once.
      var subscriber = {
        data: {
          type: 'profile',
          attributes: { email: email, properties: { newsletter_language: box.getAttribute('data-language') } }
        }
      };
      var properties = {
        pdf_url: box.getAttribute('data-pdf-url'),
        set_title: box.getAttribute('data-set-title'),
        image_url: box.getAttribute('data-image-url'),
        product_url: box.getAttribute('data-product-url'),
        product_id: box.getAttribute('data-product-id'),
        product_handle: box.getAttribute('data-product-handle'),
        level_of_detail: box.getAttribute('data-level'),
        newsletter: newsletter,
        language: box.getAttribute('data-language'),
        market: box.getAttribute('data-market'),
        page_url: location.href
      };

      // A ticked newsletter box subscribes first, so the address has its
      // consent by the time the event starts the flow.
      var subscribed = list
        ? post('subscriptions', company, {
            data: {
              type: 'subscription',
              attributes: { custom_source: 'Spalvinu PDF email', profile: subscriber },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          }).catch(function (error) {
            // A failed subscription never costs the visitor the PDF: the
            // event still goes out, flagged, and the console says why.
            console.warn('[email-pdf] newsletter subscription failed', error);
            properties.newsletter_failed = true;
            properties.newsletter_error = String(error && error.message || error).slice(0, 300);
          })
        : Promise.resolve();

      subscribed
        .then(function () {
          return post('events', company, {
            data: {
              type: 'event',
              attributes: {
                properties: properties,
                metric: { data: { type: 'metric', attributes: { name: 'Requested Coloring PDF' } } },
                profile: profile
              }
            }
          });
        })
        .then(function () {
          try {
            localStorage.setItem(STORE_KEY, email);
          } catch (e) {}
          try {
            if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
              Shopify.analytics.publish('spalvinu:email_pdf_request', {
                product_id: properties.product_id,
                product_handle: properties.product_handle,
                product_title: properties.set_title,
                newsletter: newsletter
              });
            }
          } catch (e) {}
          form.querySelector('[data-email-pdf-fields]').hidden = true;
          status.textContent = status.getAttribute('data-success');
          status.classList.add('is-success');
        })
        .catch(function (error) {
          console.warn('[email-pdf] request failed', error);
          status.textContent = status.getAttribute('data-error');
          status.classList.add('is-error');
        })
        .finally(function () {
          submit.disabled = false;
          label.textContent = idle;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var MIN_CHARS = 2;
    var DELAY_MS = 180;
    var cache = {};

    function setup(form) {
      if (form.hasAttribute('data-predictive-ready')) return;
      form.setAttribute('data-predictive-ready', '');

      var input = form.querySelector('input[name="q"]');
      var panel = form.querySelector('[data-predictive-search-panel]');
      var endpoint = form.getAttribute('data-predictive-search');
      if (!input || !panel || !endpoint) return;

      var timer = null;
      var latest = '';
      var active = -1;

      function options() {
        return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
      }

      function highlight(index) {
        var items = options();
        active = index;
        items.forEach(function (item, i) {
          item.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        if (items[index]) {
          input.setAttribute('aria-activedescendant', items[index].id);
          items[index].scrollIntoView({ block: 'nearest' });
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      }

      function close() {
        panel.hidden = true;
        panel.innerHTML = '';
        active = -1;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      }

      function show(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = doc.querySelector('[data-predictive-results]');
        if (!results || !results.children.length) return close();
        panel.innerHTML = results.innerHTML;
        panel.hidden = false;
        active = -1;
        input.setAttribute('aria-expanded', 'true');
      }

      function search(terms) {
        if (cache[terms]) return show(cache[terms]);
        var url =
          endpoint +
          '?q=' + encodeURIComponent(terms) +
          '&resources[type]=product' +
          '&resources[limit]=10' +
          '&resources[options][unavailable_products]=last' +
          '&section_id=predictive-search';
        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            cache[terms] = html;
            // A slower earlier request must not replace newer suggestions.
            if (terms === latest) show(html);
          })
          .catch(close);
      }

      input.addEventListener('input', function () {
        var terms = input.value.trim();
        latest = terms;
        clearTimeout(timer);
        if (terms.length < MIN_CHARS) return close();
        timer = setTimeout(function () { search(terms); }, DELAY_MS);
      });

      input.addEventListener('focus', function () {
        var terms = input.value.trim();
        if (terms.length >= MIN_CHARS && panel.hidden) {
          latest = terms;
          search(terms);
        }
      });

      input.addEventListener('keydown', function (event) {
        if (panel.hidden) return;
        var items = options();
        if (event.key === 'ArrowDown' && items.length) {
          event.preventDefault();
          highlight((active + 1) % items.length);
        } else if (event.key === 'ArrowUp' && items.length) {
          event.preventDefault();
          highlight(active <= 0 ? items.length - 1 : active - 1);
        } else if (event.key === 'Escape') {
          close();
        } else if (event.key === 'Enter' && items[active]) {
          // Enter on a highlighted suggestion opens it; otherwise the form
          // submits to the full results page as before.
          event.preventDefault();
          window.location.href = items[active].querySelector('a').href;
        }
      });

      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) close();
      });

      form.addEventListener('focusout', function (event) {
        if (event.relatedTarget && !form.contains(event.relatedTarget)) close();
      });
    }

    function init() {
      document.querySelectorAll('form[data-predictive-search]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // The header is re-rendered when a merchant edits it in the theme editor.
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
